import { camelCase, get } from "lodash";
import localeStrings from "./localeStrings";
import localeErrorStrings from "./localeErrorStrings";

export const translate = (text: string, selectedLanguage = "en") => {
  if (!text) return;
  const key = camelCase(text);
  const translatedString = get(localeStrings[selectedLanguage], key);
  return translatedString || text;
};

export const translateError = (code: number, selectedLanguage = "en") => {
  if (!code) return;
  const translatedString = get(localeErrorStrings[selectedLanguage], code);
  return translatedString || code;
};